export const getCourierLocationPayload = () =>
    new Promise((resolve) => {
      if (!navigator.geolocation) return resolve(null);
  
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          resolve({
            coordinates: {
              long: pos.coords.longitude,
              lat: pos.coords.latitude,
            },
            address: "",
            city: "",
          });
        },
        () => resolve(null),
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 30000 }
      );
    });
  